import {
  Box,
  Typography,
} from '@mui/material';
import { T, Icon } from '../parts/stitch';
import EindeDraaidagRapport from '../parts/EindeDraaidagRapport';
import DraaidagCard from '../parts/DraaidagCard';
import DraaidagenCalendar from '../parts/DraaidagenCalendar';
import { useProjectData } from '../ProjectDataContext';

function DraaidagenPanel({ draaidagenView, setDraaidagenView }) {
  const {
    draaidagen,
    eindeDraaidagen,
    rapportenPerDraaidag,
    losseRapporten,
  } = useProjectData();

  const draaidagenViewOptions = [
    { value: 'calendar', icon: 'calendar_month', label: 'Agenda' },
    { value: 'list', icon: 'view_list', label: 'Lijst' },
  ];

  return (
    <>
        {draaidagen.length === 0 && eindeDraaidagen.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Icon name="event" size={48} sx={{ color: T.outlineVariant, display: 'block', mx: 'auto', mb: 1 }} />
            <Typography sx={{ fontFamily: T.fontBody, color: T.outline, fontWeight: 500, mb: 1 }}>
              Geen draaidagen gevonden
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: T.fontBody, color: T.outline, maxWidth: 400, mx: 'auto' }}>
              Draaidagen worden automatisch opgehaald uit de Outlook agenda.
              Maak een nieuwe draaidag aan in de <strong>Draaidag agenda</strong> in Outlook.
            </Typography>
          </Box>
        ) : (
          <Box>
            {/* View Toggle - pill style; zinloos als er alleen losse afrondingen zijn */}
            <Box sx={{ display: draaidagen.length === 0 ? 'none' : 'flex', justifyContent: 'flex-end', mb: 2 }}>
              <Box sx={{ display: 'flex', gap: 0.5, p: 0.5, bgcolor: T.surfaceLow, borderRadius: '9999px' }}>
                {draaidagenViewOptions.map(opt => (
                  <Box
                    key={opt.value}
                    onClick={() => setDraaidagenView(opt.value)}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: 0.5,
                      px: 1.5, py: 0.5,
                      borderRadius: '9999px',
                      fontFamily: T.fontBody,
                      fontSize: '0.75rem',
                      fontWeight: draaidagenView === opt.value ? 700 : 500,
                      color: draaidagenView === opt.value ? '#fff' : T.secondary,
                      bgcolor: draaidagenView === opt.value ? T.primary : 'transparent',
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                      '&:hover': draaidagenView === opt.value ? {} : { bgcolor: T.surfaceHigh },
                    }}
                  >
                    <Icon name={opt.icon} size={16} />
                    {opt.label}
                  </Box>
                ))}
              </Box>
            </Box>

            {draaidagenView === 'calendar' ? (
              <DraaidagenCalendar draaidagen={draaidagen} />
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {draaidagen.map((draaidag) => (
                  <DraaidagCard
                    key={draaidag.id}
                    draaidag={draaidag}
                    rapporten={rapportenPerDraaidag.get(draaidag.id) || []}
                  />
                ))}
              </Box>
            )}

            {/* In de lijstweergave staan gekoppelde rapporten al in hun kaart;
                in de kalender kan dat niet, dus daar tonen we ze allemaal hier. */}
            {(draaidagenView === 'calendar' ? eindeDraaidagen : losseRapporten).length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block" mb={1}>
                  {draaidagenView === 'calendar' ? 'Afrondingen' : 'Afrondingen zonder gekoppelde draaidag'}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {(draaidagenView === 'calendar' ? eindeDraaidagen : losseRapporten).map(r => (
                    <EindeDraaidagRapport key={r.id} rapport={r} toonDraaidag />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}
    </>
  );
}

export default DraaidagenPanel;
